import { deserialize } from 'cerialize'
import { ConsentStatuses, ConsentType, TPermissions } from 'Pages/user'
import { Id } from 'Src/types/aliases'
import { BaseItem } from 'Types/item'

export class UserModel {
	@deserialize public id: Id
	@deserialize public username: string
	@deserialize public first_name: string
	@deserialize public last_name: string
	@deserialize public middle_name: string
	@deserialize public partner: BaseItem & { vat_number: string }
	@deserialize public roles: BaseItem[]
	@deserialize public email: string
	@deserialize public phone: string
	@deserialize public created_at: string
	@deserialize public updated_at: string
	@deserialize public is_active: boolean
	@deserialize public name: string
	@deserialize public lead_type: ConsentType
	@deserialize public lead_state: ConsentStatuses
	@deserialize public completed_not_actual_lead: boolean
	@deserialize public is_blocked_by_auth_attempts: boolean
	@deserialize public territorial_bank_name: string
	@deserialize public is_deleted: boolean
	@deserialize public partner_id: number
	@deserialize public permissions: TPermissions
	@deserialize public channel: BaseItem
	@deserialize public channel_id: number
	@deserialize public infotecs_token: string | null
	@deserialize public resend_api_token_info: string
	@deserialize public api_token: string
	@deserialize public last_logged_in_at: string | null
	@deserialize public password_updated_at: string | null
	@deserialize public signer: boolean
	@deserialize public is_tech: boolean
	@deserialize public working_with_subordinate_departments: boolean
	@deserialize public contained_in_external_forms: boolean
	@deserialize public department_user_relations: BaseItem[]
	@deserialize public trust_reattachment_forbidden?: boolean
	@deserialize public regions: BaseItem[]
	@deserialize public cities: BaseItem[]
	@deserialize public user_cc_type_id: number | null
	@deserialize public tab_num: string
	@deserialize public territorial_bank: BaseItem
	@deserialize public terr_manager: BaseItem
	@deserialize public gosb: BaseItem
	@deserialize public sector: BaseItem
	@deserialize public head_governance: BaseItem
	@deserialize public senior_manager: BaseItem
	@deserialize public use_api: boolean
}
